import IColumnData from "../../../common/interface/IColumnData";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

export interface ICuentaBancaria {
    id?: number;
    nroCuenta: string;
    nombre: string;
    sucursal: string;
    cbu: string;
    alias?: string;
}

export const GetCuentaBancariaColumns = (
    handleEdit: (row: any) => void,
    handleDelete: (row: any) => void
): IColumnData[] => [  
    {
        width: 80,
        label: 'Nombre',
        dataKey: 'nombre'
    },
    {
        width: 50,
        label: 'Sucursal',
        dataKey: 'sucursal'
    },
    {
        width: 40,
        label: 'Nro. de cuenta',
        dataKey: 'nroCuenta',
    },
    {
        width: 50,
        label: 'CBU',
        dataKey: 'cbu'
    },
    {
        width: 40,
        label: 'Alias',
        dataKey: 'alias',
    },
    {
        width: 20,
        label: 'Acciones',
        dataKey: 'acciones',
        cellRenderer: ({ rowData }: any) => (
            <>
                <IconButton onClick={() => handleEdit(rowData)} title="Editar">
                    <EditIcon style={{ color: 'red' }}/>
                </IconButton>
                <IconButton onClick={() => handleDelete(rowData)} title="Eliminar">
                    <DeleteIcon style={{ color: 'red' }}/>
                </IconButton>
            </>
        )
    }
];